// use yup to generate validation schema
import * as yup from 'yup';
import { t } from 'i18next';
import { ImageUpload } from 'src/components/UploadFiles';
import { PreferredContactMethod } from 'src/interfaces';

export const clientSchema = yup.object().shape({
  fullName: yup
    .string()
    .required('errors.nameRequired')
    .matches(/^.+ .+/, 'errors.firstAndLastRequired'),
  emailAddress: yup.string().required('errors.emailRequired').email('errors.emailInvalid'),
  phoneNumber: yup
    .string()
    .required('errors.phoneRequired')
    .matches(/^\d{10}$/, 'errors.phoneInvalid'),
  acceptConditions: yup.boolean().test({
    test: (value) => !!value,
    message: 'errors.acceptConditionsRequired',
    name: 'acceptConditions'
  })
});

export const patientSchema = yup.object().shape({
  name: yup.string().required('errors.patientNameRequired'),
  breed: yup.string().when('isNewPatient', {
    is: (isNewPatient: boolean) => !!isNewPatient,
    then: yup.string().required('errors.patientBreedRequired')
  }),
  age: yup.string().when('isNewPatient', {
    is: (isNewPatient: boolean) => !!isNewPatient,
    then: yup.string().required('errors.patientAgeRequired')
  }),
  sex: yup.string().when('isNewPatient', {
    is: (isNewPatient: boolean) => !!isNewPatient,
    then: yup.string().required('errors.patientSexRequired')
  }),
  isNewPatient: yup.boolean()
});

export const notificationSchema = yup.object().shape({
  smsOptIn: yup.boolean().required('errors.smsOptInRequired'),
  preferredContactMethod: yup
    .mixed<PreferredContactMethod>()
    .required('errors.preferredContactMethodRequired')
    .oneOf(Object.values(PreferredContactMethod), 'errors.preferredContactMethodInvalid')
});

export const imageUploadSchema = yup
  .object()
  .test({
    test: (imagesDict: Record<string, ImageUpload>): boolean =>
      Object.values(imagesDict).every((image: ImageUpload) => !image?.error),
    message: t('patientProfile:deleteBeforeProceeding'),
    name: 'deleteBeforeProceeding'
  })
  .test({
    test: (imagesDict: Record<string, ImageUpload>): boolean =>
      Object.values(imagesDict).every((image: ImageUpload) => !!image?.id),
    message: t('common:imagesNotReady'),
    name: 'imagesNotReady'
  })
  .default({});

export const additionalInfoSchema = yup.object().shape({
  requireComments: yup.boolean(),
  comments: yup.string().when('requireComments', {
    is: (requireComments: boolean) => !!requireComments,
    then: yup.string().required('errors.commentsRequired')
  }),
  images: imageUploadSchema
});
